
import { ICON_LIST } from './index.js'
export default {
    name: 'Icon',
    props: {
        name: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            icons: ICON_LIST,
        }
    },
    computed: {
        icon() {
            let viewboxSize = `40 40`
            if (this.icons?.[this.name].viewbox) {
                viewboxSize = `${this.icons?.[this.name]?.viewbox} ${
                    this.icons?.[this.name]?.viewbox
                }`
            } else if (
                this.icons?.[this.name].width &&
                this.icons?.[this.name].height
            ) {
                viewboxSize = `${this.icons?.[this.name].width} ${
                    this.icons?.[this.name].height
                }`
            }

            return {
                viewbox: `0 0 ${viewboxSize}`,
                path: this.icons[this.name].path,
            }
        },
    },
}
